import { createFileRoute } from "@tanstack/react-router";
import { EditProfilePage } from "@/pages/edit-profile/ui/edit-profile-page";

const EditProfileRoute = () => {
  return <EditProfilePage />;
};

export const Route = createFileRoute(
  "/_authed/$companySlug/_settings/settings/profile",
)({
  component: EditProfileRoute,
});
